export interface TradingTeamHeaderDurationIndicatorProps {
  durationDisplay?: string;
}

export const TradingTeamHeaderDurationIndicator = ({
  durationDisplay = ''
}: TradingTeamHeaderDurationIndicatorProps) => {
  return (
    <div className="bg-soFresh-140 ml-4 flex w-fit items-center self-center rounded p-3 text-xs font-medium">
      <span>{durationDisplay}</span>
    </div>
  );
};
